(() => {
  const ROOT_SELECTOR = '[data-custom-product-ingredients-v2]';

  function init(root) {
    if (!root || root.dataset.cpiInitialized === 'true') return;
    root.dataset.cpiInitialized = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-cpi-tab]'));
    const descriptionPanels = Array.from(root.querySelectorAll('[data-cpi-description]'));
    const mediaPanels = Array.from(root.querySelectorAll('[data-cpi-media]'));
    const liveRegion = root.querySelector('[data-cpi-live-region]');

    if (!buttons.length) return;

    function activate(blockId, clickedButton) {
      buttons.forEach((button) => {
        const active = button.dataset.cpiTab === blockId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');

        if (button.closest('.custom-product-ingredients-v2__mobile-tabs')) {
          button.tabIndex = active ? 0 : -1;
        }
      });

      descriptionPanels.forEach((panel) => {
        const active = panel.dataset.cpiDescription === blockId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      mediaPanels.forEach((panel) => {
        const active = panel.dataset.cpiMedia === blockId;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      const matchingButton = clickedButton || buttons.find((button) => button.dataset.cpiTab === blockId);
      const label = matchingButton?.textContent?.trim() || '';

      if (liveRegion && label) {
        liveRegion.textContent = `${label} selected`;
      }

      const mobileButton = buttons.find(
        (button) =>
          button.dataset.cpiTab === blockId &&
          button.closest('.custom-product-ingredients-v2__mobile-tabs')
      );

      if (mobileButton && window.matchMedia('(max-width: 749px)').matches) {
        const mobileTabs = mobileButton.closest('.custom-product-ingredients-v2__mobile-tabs');

        if (mobileTabs) {
          const left =
            mobileButton.offsetLeft -
            (mobileTabs.clientWidth - mobileButton.offsetWidth) / 2;

          mobileTabs.scrollTo({
            left: Math.max(0, left),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth'
          });
        }
      }



    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button.dataset.cpiTab, button));

      button.addEventListener('keydown', (event) => {
        if (!button.closest('[role="tablist"]')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        const group = buttons.filter(
          (item) => item.closest('[role="tablist"]') === button.closest('[role="tablist"]')
        );

        const index = group.indexOf(button);
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % group.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + group.length) % group.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = group.length - 1;

        event.preventDefault();
        group[nextIndex].focus();
        activate(group[nextIndex].dataset.cpiTab, group[nextIndex]);
      });
    });

    const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
    activate(initial.dataset.cpiTab, initial);
  }

  function initAll(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) init(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
